<template>
  <!-- -->
  <div class="notice-component">
    <el-popover trigger="click" :width="300" popper-class="notice-popper" ref="popover" :visible="popVisible">
      <template #reference>
        <div class="tips-notice item" @click.stop="toggleMessageList">
          <yq-icon name="element-ui_message"/>
          <div class="notice-count" v-if="noticeCount > 0">{{ noticeCount > 99 ? '99+' : noticeCount }}</div>
        </div>
      </template>
      <div class="notice-list" @click.stop="doNothing">
        <div class="notice-title">
          <div class="status">
            <span class="status-btn" :class="messageSearchInfo.searchType === ''? 'active': ''" @click="resetQueryMessageSearch('')">全部</span>
            <span class="status-btn" :class="messageSearchInfo.searchType === '0'? 'active': ''" @click="resetQueryMessageSearch('0')">未读</span>
            <span class="status-btn" :class="messageSearchInfo.searchType === '1'? 'active': ''" @click="resetQueryMessageSearch('1')">已读</span>
          </div>
          <div class="options">
            <el-checkbox v-model="selectAll" :indeterminate="selectHalf" @change="toSelectAll"><span class="select-all">全选</span></el-checkbox>
            <table-button :disabled="(!selectHalf && !selectAll) || selectedNoticeIds.length === 0" @click="readSelectedNotice">
              <span :class="((!selectHalf && !selectAll) || selectedNoticeIds.length === 0)? 'select-all disabled': 'select-all'">设为已读</span>
            </table-button>
          </div>
        </div>
        <!--
          未读消息的分类统计：只在「未读」页签下展示（已读/全部的分类条数对用户没有指引意义）。
          点某一类只看该类消息，再点一次取消筛选回到全部类型。
        -->
        <div class="notice-type-count" v-if="isUnreadSearch && noticeTypeCountList.length > 0">
          <span v-for="item in noticeTypeCountList" :key="item.noticeType"
                class="type-btn" :class="messageSearchInfo.category === item.noticeType ? 'active' : ''"
                @click="toSearchNoticeType(item.noticeType)">
            {{getMessageType(item.noticeType)}}({{item.noticeCount}})
          </span>
        </div>
        <div class="notice-data-list" @scroll="scrollNoticeList">
          <div v-if="noticeList.length === 0">
            <div class="empty-icon">📭</div>
            <div class="empty-text">暂无消息</div>
          </div>
          <div v-for="(item, idx) in noticeList" :key="idx" class="notice-item" v-else>
            <div class="message-type">{{noticeTypeName(item)}}</div>
            <div class="checkbox">
              <el-checkbox v-model="item.selected" @change="checkboxChange"/>
            </div>
            <div class="notice-info" @click="toShowNoticeDetail(item)">
              <div class="title"><span :class="item.readStatus === 0? 'title-icon': 'title-icon read'"/>{{noticeTitle(item)}}</div>
              <div class="time">{{item.messageTime}}</div>
              <!--
                摘要优先用系统消息的 summary（公告/预警，富文本，走 v-html）；
                提醒类消息没有系统消息行，取不到 summary，回退到渲染好的正文。
                ★ 正文里可能混着客户名之类的业务数据，回退这一支用纯文本渲染，不走 v-html
              -->
              <div class="summary" v-if="item.summary" v-html="item.summary"/>
              <div class="summary" v-else>{{item.noticeContent}}</div>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
    <el-dialog append-to-body v-model="showDialog" title="消息提醒" dialog-width="2">
      <form-items :columns="1" label-width="2.4rem">
        <form-item label="消息标题">{{noticeDialogTitle(currentNotice)}}</form-item>
        <form-item label="消息类型">{{noticeTypeName(currentNotice)}}</form-item>
        <form-item label="接收时间">{{currentNotice.messageTime}}</form-item>
        <form-item label="摘要" >
          <div class="summary-text" v-if="currentNotice.summary" v-html="currentNotice.summary"/>
          <div class="summary-text" v-else>{{currentNotice.noticeContent}}</div>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="hideDialog">取消</page-button>
        <page-button v-if="messageDeal(noticeTypeOf(currentNotice))" @click="toDealMessage" el-type="primary">处理消息</page-button>
        <page-button v-else @click="toMessageList" el-type="primary">查看消息列表</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import YqIcon from "@/components/YqIcon.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";

export default {
  props: {
    queryNoticeList: {type: Function, default: null}, // 查询消息列表
    queryNoticeTypeCount: {type: Function, default: null}, // 查询未读消息的分类统计
    readNotice: {type: Function, default: null}, // 标记已读
    noticeCount: {type: Number, default: 0}, // 未读消息
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    FormItem, FormItems,
    TableButton, YqIcon
  },
  data() {
    return {
      messageSearchInfo: {
        searchType: '',
        category: '', // 未读时选中的消息类型，空串=全部类型
        hasNext: true,
      },
      noticeTypeCountList: [], // 未读消息按类型的统计
      selectHalf: false, // 选中某些数据
      selectAll: false, // 全选
      showDialog: false,
      currentNotice: {
        messageTime: "",
        messageType: "",
        messageTitle: "",
        summary: "",
        readStatus: 0,
      },
      noticeList:[],
      selectedNoticeIds: [],
      popVisible: false, // 通过visible进行手动控制显示和隐藏
    };
  },
  computed: {
    // 当前是否处于「未读」页签，统计层只在此页签下展示
    isUnreadSearch() {
      return this.messageSearchInfo.searchType === '0';
    },
  },
  created() {
    window.addEventListener("click", this.clickOther);
  },
  unmounted() {
    window.removeEventListener("click", this.clickOther);
  },
  methods: {
    /**
     * 消息类型 code。
     *
     * ★ 以 messageType 为准（栈表已与消息系统对齐，自己就存着它，提醒类消息没有系统消息行也拿得到）。
     *   noticeType 是栈表原有的同值字段，留作兜底：加列之前的历史行 messageType 是空的。
     */
    noticeTypeOf(notice) {
      if (!notice) {
        return "";
      }
      return notice.messageType || notice.noticeType || "";
    },
    /**
     * 消息类型名，添加新的消息类型时，需要修改这里。
     * 分类统计拿到的也是这套 code（统计的是消息栈的 notice_type），同样走这个映射渲染。
     */
    getMessageType(messageType) {
      switch (messageType) {
        case "PROCLAMATION":
          return "系统公告";
        case "AI_LOGOUT_WARN":
          return "AI员工登出提醒";
        case "LUQIAO_STRANGER":
          return "陌生人预警";
        case "LUQIAO_HELMET":
          return "安全帽预警";
        case "LUQIAO_TASK_WARN":
          return "工作计划预警";
        case "LUQIAO_ATTENDANCE_WARN":
          return "考勤预警";
        case "LUQIAO_BLACK_LIST":
          return "黑名单提醒";
        case "PROCESS_APPROVAL":
          return "待审批";
        case "NOTICE_TYPE":
          return "提醒消息";
      }
      return "";
    },
    /**
     * 列表/弹框上显示的类型名。
     *
     * 提醒类型是一类消息（日历日程、客户到期…都挂在它下面），笼统显示「提醒消息」看不出是什么事，
     * 所以再按 businessType 细分一层。分类统计那一栏是按 notice_type 分组统计的（后端 countNoticeByType），
     * 只能显示到「提醒消息」这一层，两者粒度不同是有意的。
     */
    noticeTypeName(notice) {
      const type = this.noticeTypeOf(notice);
      if (type === "NOTICE_TYPE") {
        const businessType = (notice && notice.businessType) || "";
        if (businessType === "calendar") {
          return "日程提醒";
        }
        if (businessType === "subscript") {
          return "客户到期提醒";
        }
      }
      return this.getMessageType(type);
    },
    /**
     * 标题：公告/预警取系统消息的标题；提醒类消息没有系统消息行，取不到标题，
     * 直接用渲染好的正文顶上 —— 列表里至少要有能看出这是什么的一条文字。
     */
    noticeTitle(notice) {
      if (!notice) {
        return "";
      }
      return notice.messageTitle || notice.noticeContent || "";
    },
    /**
     * 弹框里的标题：没有系统消息标题时用类型名兜底。
     * ★ 不要跟着列表一起回退到正文 —— 弹框下面还有「摘要」一格，
     *   两格显示同一段正文看着像重复渲染。
     */
    noticeDialogTitle(notice) {
      if (!notice) {
        return "";
      }
      return notice.messageTitle || this.noticeTypeName(notice) || "";
    },
    // 这些消息点开后能直接跳到对应业务页处理，其余只能去消息列表看
    messageDeal(messageType) {
      //         ai员工登出，重新登录 考勤异常，补卡 待审批，去审批中心 提醒消息，去日程/客户到期
      let arr = ["AI_LOGOUT_WARN", "LUQIAO_ATTENDANCE_WARN", "PROCESS_APPROVAL", "NOTICE_TYPE"];
      for (let i = 0; i < arr.length; i++) {
        if (messageType === arr[i]) {
          return true;
        }
      }
      return false;
    },
    // 打死系统预警消息列表
    toMessageList() {
      this.showDialog = false;
      this.router.push(`/sys/warning`);
      this.popVisible = false;
    },
    // 处理消息，添加新的消息类型时，需要修改这里。
    // ★ 类型判断一律用 noticeTypeOf：提醒类消息联表出来的 messageType 是空的
    toDealMessage() {
      this.showDialog = false;
      const messageType = this.noticeTypeOf(this.currentNotice);
      if (messageType === "PROCLAMATION") { // 系统公告
        this.router.push(`/sys/message/view?id=${this.currentNotice.messageId}`)
      } else if (messageType === "AI_LOGOUT_WARN") { // AI员工登出提醒
        this.router.push(`/qywx/quotation/robot-employee`)
      } else if (messageType === "LUQIAO_ATTENDANCE_WARN") { // 考勤预警，跳转到考勤页面
        // 跳转到考勤的具体页面
        this.router.push(`/laborers/attendance?type=WORK&id=${this.currentNotice.businessId}&date=${this.currentNotice.messageTime}`);
      } else if (messageType === "LUQIAO_TASK_WARN") { // 工作计划预警，跳转到工作任务页面
        this.router.push(`/checkWarranty/plan/record`);
      } else if (messageType === "PROCESS_APPROVAL") { // 待审批，跳转到审批中心待办列表
        this.router.push(`/project/view/check`);
      } else if (messageType === "NOTICE_TYPE") { // 提醒类型，按业务键分发
        if (!this.toNoticeBusiness()) {
          // 认不出业务键（发送侧没写、或以后新增的业务类型前端还没补跳转）：
          // 退回消息列表，别让用户点了「处理消息」却什么都没发生
          this.toMessageList();
          return;
        }
      }
      this.popVisible = false;
    },
    /**
     * 提醒类消息的分发：按 businessType 跳业务页，businessId 带上定位用的业务主键。
     *
     * <p>两者都由发送侧写进栈内消息行（后端 sendNotice 的 businessType / businessId）：
     * businessType 说明是哪一类提醒（calendar 日程 / subscript 客户到期），
     * businessId 是那类业务的主键（日程日期 / 订阅id）。
     * 新增一类提醒时，在 {@link #noticeTypeName} 里补显示名、在这里补跳转即可。
     *
     * @returns {boolean} 是否跳转成功；认不出业务类型时返回 false
     */
    toNoticeBusiness() {
      const businessType = this.currentNotice.businessType;
      const businessId = this.currentNotice.businessId;
      if (businessType === "calendar") {
        // 目标日历按 date 参数默认选中当天（没有业务主键时日历自己落到今天）
        this.router.push(businessId ? `/project/view/calendar?date=${businessId}` : `/project/view/calendar`);
        return true;
      }
      if (businessType === "subscript") {
        // 客户到期档案详情；没有业务主键时退回列表页，别跳到一个查不到数据的详情页
        this.router.push(businessId ? `/customer/expire/detail?id=${businessId}` : `/customer/expire`);
        return true;
      }
      console.warn("未知的提醒业务类型，无法跳转", businessType);
      return false;
    },
    clickOther(event) {
      if (event.target.className === 'el-overlay-dialog') {// 点击弹窗
        return;
      }
      if (event.target.parentElement && event.target.parentElement.className === "el-icon el-dialog__close") {
        return;
      }
      this.popVisible = false;
    },
    doNothing() {

    },

    // 勾选、取消勾选时
    checkboxChange() {
      let allNotSelected = true; // 一条都没有选中
      let allSelected = true; // 所有数据全部选中
      let selectedNoticeIds = []; // 勾选选中的数据
      for (let i = 0; i < this.noticeList.length; i++) {
        if (this.noticeList[i].selected) { // 有一条数据选中了
          allNotSelected = false; // 一条都没有选中，false
          selectedNoticeIds.push(this.noticeList[i].id);
        } else {
          allSelected = false; // 所有数据全部选中，false
        }
      }
      this.selectAll = allSelected;
      this.selectHalf = !allNotSelected && !allSelected;
      this.selectedNoticeIds = selectedNoticeIds;
    },
    // 全选的选中和非选中
    toSelectAll(selected) {
      let selectedNoticeIds = [];
      // 全选、取消全选
      this.selectHalf = false;
      for (let i = 0; i < this.noticeList.length; i++) {
        this.noticeList[i].selected = selected;
        if (selected) {
          selectedNoticeIds.push(this.noticeList[i].id);
        }
      }
      this.selectedNoticeIds = selectedNoticeIds;
    },
    // 当消息滚动时，如果是向上滚动，并且滚动到底的时候，判断是否需要加载更多数据
    scrollNoticeList(event) {
      if (event.target.scrollTop > 0 && event.target.scrollHeight - event.target.scrollTop <= event.target.clientHeight) {
        if (!this.messageSearchInfo.hasNext) {
          return;// 没有下一页的数据了
        }
        // 滚动到底部
        this.messageSearchInfo.pageNumber++;
        this.queryMessageList();
      }
    },
    toShowNoticeDetail(data) {
      this.currentNotice = data;
      this.showDialog = true;
      if (data.readStatus !== 1) {
        data.readStatus = 1; //消息标为已读
        // 消息标记为已读
        this.readNotice(1, [data.id]); // web端读取消息
      }
    },

    toggleMessageList() {
      this.popVisible = true;
      this.resetQueryMessageSearch("0"); // 加载未读消息
    },
    // 搜索消息列表
    queryMessageList() {
      // 搜索消息列表
      this.queryNoticeList(this.messageSearchInfo).then(res => {
        if (res.records && res.records.length > 0) {
          // 加入了新的数据，全选
          this.selectAll = false;
          if (this.selectedNoticeIds.length > 0) {
            this.selectHalf = true;
          }
        }
        this.noticeList = this.noticeList.concat(res.records);
        // 是否还有下一页
        this.messageSearchInfo.hasNext = res.pageCount > this.messageSearchInfo.pageNumber;
      })
    },
    // 查询未读消息的分类统计，上游未提供该能力时静默跳过，统计层不展示
    queryTypeCount() {
      if (!this.queryNoticeTypeCount) {
        this.noticeTypeCountList = [];
        return;
      }
      this.queryNoticeTypeCount().then(list => {
        this.noticeTypeCountList = list || [];
      });
    },
    // 点某一类只看该类消息，再点一次取消筛选回到全部类型
    toSearchNoticeType(noticeType) {
      this.messageSearchInfo.category = this.messageSearchInfo.category === noticeType ? '' : noticeType;
      this.resetQueryMessageSearch(this.messageSearchInfo.searchType);
    },
    // 重置notice消息查询条件
    resetQueryMessageSearch(status) {
      this.messageSearchInfo.searchType = status;
      // 切回「全部/已读」时清掉类型筛选：类型统计只在未读下展示，
      // 残留的筛选会让用户在看不到任何筛选入口的页签里，只看到一部分消息
      if (status !== '0') {
        this.messageSearchInfo.category = '';
      }
      this.messageSearchInfo.pageNumber = 1;
      this.messageSearchInfo.hasNext = true;
      this.noticeList = [];
      // 重置条件时，选中的数据全部取消
      this.selectAll = false;
      this.selectHalf = false;
      this.selectedNoticeIds = [];
      this.queryMessageList();
      // 统计只针对未读，其它页签不必查
      if (status === '0') {
        this.queryTypeCount();
      }
    },
    // 将勾选的全部消息设置为已读
    readSelectedNotice() {
      // 列表中的消息，有哪些是未读的
      let arrIds = [];
      for (let i = 0; i < this.noticeList.length; i++) {
        if (this.noticeList[i].selected && this.noticeList[i].readStatus !== 1) {
          arrIds.push(this.noticeList[i].id);
        }
      }
      if (arrIds.length > 0) {
        this.readNotice(1, arrIds);
        this.resetQueryMessageSearch(this.messageSearchInfo.searchType); // 刷新页面，同时刷新未读统计
      }
    },
    // 隐藏弹框，此时popover会关闭，禁止pop关闭
    hideDialog() {
      this.showDialog = false;
      // 不隐藏popover
    }
  }
};
</script>
<style lang="scss">
.el-popper.notice-popper{
  padding: 0;
  border-radius: 6px;
}
</style>
<style lang="scss" scoped>
.notice-component{
  margin-right: 10px;
}
.summary-text{
  :deep(img) {
    width: 100%;
    height: auto !important;
  }
}
.tips-notice {
  position: relative;
  font-size: 16px;
  .notice-count {
    position: absolute;
    top: 0;
    right: -50%;
    font-size: 9px;
    background: var(--el-color-danger);
    height: 10px;
    line-height: 10px;
    padding: 2px;
    border-radius: 10px;
    color: #FFF;
    min-width: 12px;
    text-align: center;
  }
}
.notice-list{
  .notice-title{
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--yq-border-color);
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 6px 6px 0 0;
    .status{
      .status-btn{
        color: #FFF;
        font-size: var(--yq-font-size-small);
        margin-right: 10px;
        display: inline-block;
        width: 30px;
        cursor: pointer;
        &.active{
          font-size: var(--yq-font-size-base);
          font-weight: 600;
        }
      }
    }
    .options{
      display: inline-flex;
      :deep(.el-checkbox){
        height: 16px;
        line-height: 16px;
        margin-right: 10px;
        .el-checkbox__label{
          padding-left: 0;
        }
      }
      .select-all{
        color: #FFF;
        font-size: var(--yq-font-size-small);
        &.disabled{
          color: var(--yq-font-color-desc);
        }
      }
    }
  }
  .notice-type-count{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 20px 0;
    .type-btn{
      padding: 2px 10px;
      font-size: var(--yq-font-size-small);
      color: var(--yq-font-color-tips);
      background: var(--yq-background-color);
      border: 1px solid transparent;
      border-radius: 12px;
      cursor: pointer;
      &.active{
        color: var(--el-color-primary);
        border-color: var(--el-color-primary);
      }
    }
  }
  .notice-data-list{
    height: 500px;
    overflow: auto;
    padding: 0 20px;
    .empty-text{
      text-align: center;
      color: var(--yq-font-color-desc);
    }
    .empty-icon{
      margin-top: 50px;
      text-align: center;
      font-size: 48px;
      margin-bottom: 16px;
    }
    .notice-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding: 10px 0;
      border-bottom: 1px solid var(--yq-border-color);
      .message-type{
        position: absolute;
        top: 10px;
        right: 0;
        font-size: var(--yq-font-size-small);
        scale: 0.8;
        transform-origin: right;
      }
      .checkbox{
        width: 20px;
      }
      .notice-info{
        flex: 1;
        width: 100px;
        .title{
          font-size: var(--yq-font-size-base);
          white-space: nowrap;
          overflow: hidden;
          margin-right: 40px;
          text-overflow: ellipsis;
          color: var(--yq-font-color-base);
          font-weight: 500;
          .title-icon{
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 8px;
            background: var(--el-color-danger);
            margin-right: 5px;
            &.read{
              background: var(--yq-font-color-desc);
            }
          }
        }
        .time{
          font-size: var(--yq-font-size-small);
          color: var(--yq-font-color-desc);
        }
        .summary{
          color: var(--yq-font-color-desc);
          font-size: var(--yq-font-size-small);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          :deep(img){
            max-width: 100%;
            height: auto !important;
            display: none;
          }
          :deep(p) {
            margin: 0;
          }
        }
      }
    }
  }
}

</style>